var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoocfiLogo = function SvgMoocfiLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 22,
    fill: "none",
    role: "presentation"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#313947",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M14.42 14.46a6.71 6.71 0 1 1-13.42 0C1 8.7 7.71 2 7.71 2s6.71 6.7 6.71 12.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#313947",
    strokeMiterlimit: 10,
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    d: "M7.712 17.33a2.88 2.88 0 0 1-2.88-2.87"
  })));
};
export default SvgMoocfiLogo;